/**
 * Maps channels that have already been run through the sortParentAndChildChannels
 * mixin into Dropdown items for the Channel Dependency selectors.
 *
 * `text` is the mixin-formatted label shown in the dropdown. It carries the brand
 * and the parent/child tree indentation so channels that share a name across
 * brands can be told apart.
 *
 * `previewName` is the clean "<name> (<brand>)" form used in the confirmation
 * preview sentence, without the tree glyphs the formatted label uses (those read
 * badly mid-sentence). It is derived from the original, unformatted name the mixin
 * preserves on each channel.
 */
export function buildChannelItems (formattedChannels) {
	return formattedChannels.map(channel => ({
		text: channel.channelName,
		value: channel.channelId,
		previewName: `${channel.originalChannelName} (${channel.brandName})`
	}))
}
